import { useState, useEffect } from "react";
import { Menu, X, AudioLines } from "lucide-react";

const NAV_LINKS = [
  { label: "Features", href: "#features" },
  { label: "Channels", href: "#channels" },
  { label: "Industries", href: "#industries" },
  { label: "Compare", href: "#compare" },
  { label: "FAQ", href: "#faq" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#050505]/80 border-b border-white/10 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-2.5 group">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand shadow-[0_0_20px_rgba(255,92,0,0.5)] transition-transform group-hover:scale-105">
            <AudioLines className="h-5 w-5 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-heading text-xl font-extrabold tracking-tight text-white">
            5B<span className="text-brand"> AI</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-white/60 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contact"
            data-testid="header-login"
            className="text-sm font-medium text-white/70 hover:text-white transition-colors px-3 py-2"
          >
            Log in
          </a>
          <a
            href="https://api.leadconnectorhq.com/widget/booking/1O9DVPsKwdzHA4TLdUny"
            data-testid="header-cta"
            className="text-sm font-semibold text-white bg-brand hover:bg-brand-hover px-5 py-2.5 rounded-full transition-all duration-300 hover:brightness-110 active:scale-95 shadow-[0_0_24px_rgba(255,92,0,0.35)]"
          >
            Get Started
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden mt-3 mx-4 rounded-2xl border border-white/10 bg-[#0c0c0c] p-5 flex flex-col gap-2"
        >
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="py-2.5 text-base font-medium text-white/80 hover:text-brand transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="https://api.leadconnectorhq.com/widget/booking/1O9DVPsKwdzHA4TLdUny"
            onClick={() => setOpen(false)}
            className="mt-2 text-center text-sm font-semibold text-white bg-brand px-5 py-3 rounded-full"
          >
            Get Started
          </a>
        </div>
      )}
    </header>
  );
};
